class TextEncodingUtil {
    /** Encode a string to a Uint8Array using UTF-8 encoding.  */
    static encodeToUTF8(input) {
        if (TextEncodingUtil.isServer) {
            return new Uint8Array(Buffer.from(input, 'utf-8'));
        }
        const encoder = new TextEncoder();
        return encoder.encode(input);
    }
    /** Decode a Uint8Array to a string using UTF-8 encoding.  */
    static decodeFromUTF8(input) {
        if (TextEncodingUtil.isServer) {
            return Buffer.from(input).toString('utf-8');
        }
        const decoder = new TextDecoder('utf-8');
        return decoder.decode(input);
    }
    /** Base64 encode a string in UTF-8 */
    static base64Encode(input) {
        if (TextEncodingUtil.isServer) {
            return Buffer.from(input, 'utf-8').toString('base64');
        }
        const utf8Array = TextEncodingUtil.encodeToUTF8(input);
        const binary = Array.from(utf8Array, (byte) => String.fromCharCode(byte)).join('');
        return btoa(binary);
    }
    /** Base64 decode a string to UTF-8 */
    static base64Decode(input) {
        if (TextEncodingUtil.isServer) {
            return Buffer.from(input, 'base64').toString('utf-8');
        }
        const binary = atob(input);
        const utf8Array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            utf8Array[i] = binary.charCodeAt(i);
        }
        return TextEncodingUtil.decodeFromUTF8(utf8Array);
    }
}
TextEncodingUtil.isServer = typeof window === 'undefined';
export default TextEncodingUtil;
